export function ensureString<TFallback>(value: unknown, fallback: TFallback): string | TFallback {
    return typeof value === 'string' ? value : fallback;
}
